import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperPropretyTimeLine: {
    width: "100%",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  divider: {
    marginTop: "24px",
  },
  containerDate: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
  },
  containerIconAndVerticalLine: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    paddingBottom: "4px",
  },
  timelineConnector: {
    backgroundColor: theme.palette.background.gray_200,
    height: "12px",
    width: "2px",
    margin: "auto",
    borderRadius: "6px",
  },
  containerData: {
    display: "flex",
    flexDirection: "column",
    padding: "0px  0px 24px 0px",
  },
}));
